// CONSTANTS DATA

const DEFAULT_STATE_DATA = {

    ACTIONS_STRINGS: {
        ON_CLICK_DEFAULT_ALERT: 'This is default "onClick", probably the function is not defined.',
        ON_CHANGE_DEFAULT_ALERT: 'This is default "onChange", probably the function is not defined.',
    },

    VARIABLES: {
        MAX_MOBILE_SCREEN_WIDTH: 600,
        MAX_TABLET_SCREEN_WIDTH: 768,
        MAX_DESKTOP_SCREEN_WIDTH: 1024,
    },
};

export default DEFAULT_STATE_DATA;